__turbopack_context__.v({
  "jobDeliverablesStep": "UK6RuW_jobDeliverablesStep",
  "jobDeliverablesStep__controls": "UK6RuW_jobDeliverablesStep__controls",
  "jobDeliverablesStep__detailsContent": "UK6RuW_jobDeliverablesStep__detailsContent",
  "jobDeliverablesStep__detailsRow": "UK6RuW_jobDeliverablesStep__detailsRow",
  "jobDeliverablesStep__dragHandle": "UK6RuW_jobDeliverablesStep__dragHandle",
  "jobDeliverablesStep__footer": "UK6RuW_jobDeliverablesStep__footer",
  "jobDeliverablesStep__nameActions": "UK6RuW_jobDeliverablesStep__nameActions",
  "jobDeliverablesStep__nameCell": "UK6RuW_jobDeliverablesStep__nameCell",
  "jobDeliverablesStep__nameEditor": "UK6RuW_jobDeliverablesStep__nameEditor",
  "jobDeliverablesStep__panel": "UK6RuW_jobDeliverablesStep__panel",
  "jobDeliverablesStep__panelHeader": "UK6RuW_jobDeliverablesStep__panelHeader",
  "jobDeliverablesStep__panelIntro": "UK6RuW_jobDeliverablesStep__panelIntro",
  "jobDeliverablesStep__panelText": "UK6RuW_jobDeliverablesStep__panelText",
  "jobDeliverablesStep__panelTitle": "UK6RuW_jobDeliverablesStep__panelTitle",
  "jobDeliverablesStep__serviceTypeSelect": "UK6RuW_jobDeliverablesStep__serviceTypeSelect",
  "jobDeliverablesStep__subtitle": "UK6RuW_jobDeliverablesStep__subtitle",
  "jobDeliverablesStep__table": "UK6RuW_jobDeliverablesStep__table",
  "jobDeliverablesStep__title": "UK6RuW_jobDeliverablesStep__title",
});
